import _ from 'lodash';
import React from 'react';
import { memberStatuses } from '~/lookups';
import SingleSelectFilter from './SingleSelectFilter';

const defaultOptions = _.values(memberStatuses);

export default function MemberStatusFilter({
  placeholder = 'Member Status',
  name,
  value,
  onChange,
  options = defaultOptions,
}) {
  return (
    <SingleSelectFilter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.name}
      options={options}
      onChange={onChange}
    />
  );
}
